module.exports = __webpack_public_path__ + "img/user-guide-flow-diagram.pt_pt.f12aa0cb.png";